import React from 'react';
import { Button } from '@progress/kendo-react-buttons';

const CancelChangesButton = ({ onDiscard, disabled }) => (
    <Button
      onClick={onDiscard}
      disabled={disabled}
      className="k-button k-button-solid-primary"
      icon="k-icon k-i-cancel"
    >
      Discard Changes
    </Button>
  );

  export default CancelChangesButton;